<template>
  <div class="IntroCarousselContainer">
    <div class="ContentContainer">
      <div class="displayflex flexbetween colorDarkBlue fontsize20">
        <div>Was ist neu im Verkehrsservice?</div>
        <SVGIcon
          @click.native="close"
          name="close"
          class="selfAlignCenter cursor-pointer"
          size="small"
        />
      </div>
      <div v-if="activeIndex===1" class="page">
        <div class="displayflex flexaround marginbottom20">
          <SVGIcon name="e_tankstelle_green" style="height:75px;width:75px;"/>
          <SVGIcon name="user_on" style="height:80px;width:50px;"/>
          <div class="displayflex">
            <SVGIcon name="stau_off" class="selfAlignCenter"/>
            <div class="marginleft15 selfAlignCenter">Trend + 30 Min.</div>
          </div>
        </div>

        <p class="colorDarkGrey">Diese Services haben wir neu für Sie eingerichtet:</p>
        <ul>
          <li>Persönliche Route anlegen</li>
          <li>Nachrichten erhalten zu aktuellen Verkehrsstörungen</li>
          <li>e-Tankstellen finden an hessischen Autobahnen</li>
          <li>30-Minuten-Prognose auf die Verkehrslage</li>
        </ul>
        <p></p>
        <div
          class="colorBlue lineHeight20 marginbottom20 cursor-pointer"
          @click="activeIndex++"
        >Weiter...</div>
      </div>

      <!-- ########################################################### -->
      <div v-if="activeIndex===2" class="page">
        <div class="displayflex marginbottom20 margintop20">
          <SVGIcon name="user_on"/>
          <div class="colorLightGrey selfAlignCenter marginleft15 fontsize18">Mein Verkehrsservice</div>
        </div>

        <div class="displayflexColumn">
          <div class="colorDarkBlue fontsize16 marginbottom10 lineHeight20">Meine Kartenansicht</div>
          <div class="displayflex flexrow">
            <SVGIcon name="kartenausschnitt" style="height:75px; width:75px; margin-left:27.5px;"/>
            <div class="displayflexColumn" style="margin-left:35px; padding-top:10px">
              <div>Beim Aufruf immer das sehen, was Sie interessiert:</div>
              <ul>
                <li>Kartenansicht</li>
                <li>eingeblendete Informationen</li>
              </ul>
            </div>
          </div>
        </div>

        <div
          class="colorBlue lineHeight20 marginbottom20 cursor-pointer"
          @click="activeIndex++"
        >Weiter...</div>
      </div>

      <!-- ########################################################### -->
      <div v-if="activeIndex===3" class="page">
        <div class="displayflex marginbottom20 margintop20">
          <SVGIcon name="user_on"/>
          <div class="colorLightGrey selfAlignCenter marginleft15 fontsize18">Mein Verkehrsservice</div>
        </div>

        <div class="displayflexColumn">
          <div class="colorDarkBlue fontsize16 marginbottom10 lineHeight20">Meine Strecken</div>
          <div class="displayflex flexrow">
            <SVGIcon
              name="route"
              class="selfAlignCenter"
              style="height:75px; width:75px; margin-left:17.5px;"
            />
            <div class="displayflexColumn" style="padding-top:15px">
              <ul>
                <li>Eigene Strecken festlegen.</li>
                <li>Aktuelle Meldungen dazu schnell im Blick</li>
              </ul>
            </div>
          </div>
        </div>

        <div
          class="colorBlue lineHeight20 marginbottom20 cursor-pointer"
          @click="activeIndex++"
        >Weiter...</div>
      </div>

      <!-- ########################################################### -->
      <div v-if="activeIndex===4" class="page">
        <div class="displayflex marginbottom20 margintop20">
          <SVGIcon name="user_on"/>
          <div class="colorLightGrey selfAlignCenter marginleft15 fontsize18">Mein Verkehrsservice</div>
        </div>

        <div class="displayflexColumn">
          <div class="colorDarkBlue fontsize16 marginbottom10 lineHeight20">Benachrichtigungen</div>
          <div class="displayflex flexrow paddingtop10">
            <SVGIcon name="benachrichtigung" style="width:75px; margin-left:27.5px;"/>
            <div  style="margin-left:35px;">
              Auf mobilen Geräten können Sie sich zu jeder Route über aktuelle
              Verkehrsbehinderungen benachrichtigen lassen.
            </div>
          </div>
        </div>

        <div
          class="colorBlue lineHeight20 marginbottom20 cursor-pointer"
          @click="activeIndex++"
        >Weiter...</div>
      </div>

      <!-- ########################################################### -->
      <!-- <div v-if="activeIndex===3" class="page">
        <div
          class="benachrichtigungBeispiel borderRadius5 displayflex flexbetween borderGrey borderStyleSolid borderWidth1 padding10 marginbottom20"
        >
          <SVGIcon
            name="benachrichtungBeispielIcon"
            class="selfAlignCenter"
            style="height:115px; width:115px"
          />
          <SVGIcon name="stau_on" class="selfAlignCenter marginleft5" v-if="device !== 'XS'"/>
          <div class="displayflexColumn width100 marginleft5">
            <div>Ins Büro</div>
            <div class="displayflex flexbetween fontweight600">
              <div>Stau 4km</div>
              <div class="backgroundYellow borderRadius30" style="padding:0 10px">+ 5 min.</div>
            </div>
            <div>Mainz → Wiesbaden</div>
            <div>linker Fahrstreifen gesperrt</div>
          </div>
        </div>

        <div class="displayflex marginbottom20">
          <SVGIcon name="benachrichtigung" class="selfAlignCenter" style="height:75px;width:75px"/>
          <div
            class="colorDarkBlue marginleft15 fontsize22 lineHeight20 selfAlignCenter"
          >Pushbenachrichtigungen</div>
        </div>

        <div
          class="colorDarkGrey lineHeight20 marginbottom20"
        >zu jeder Route können Sie sich in einem von Ihnen gewählten Zeitraum über Verkehrsbehinderungen benachrichtigen lassen...</div>

        <div
          class="colorBlue lineHeight20 marginbottom20 cursor-pointer"
          @click="activeIndex++"
        >Weiter...</div>
      </div>-->
      <!-- ########################################################### -->
      <div v-if="activeIndex===5" class="page">
        <div class="displayflex flexaround marginbottom20 margintop20">
          <SVGIcon name="user_on_kreis"/>
          <SVGIcon name="id_transfer" style="width:72px;"/>
        </div>

        <div class="colorDarkBlue fontsize18 lineHeight20 marginbottom20">Auf allen Geräten nutzbar</div>

        <div
          class="colorDarkGrey lineHeight20 marginbottom20"
        >Mit einem persönlichen Profil können Sie angelegte Routen auf allen Ihren Geräten nutzen.</div>

        <div class="colorBlue lineHeight20 marginbottom20 cursor-pointer" @click="close">Los geht's</div>
      </div>

      <div
        class="displayflex flexaround"
        :style="device === 'XS' ? 'margin:0 20px;' :'margin: 0 80px;'"
      >
        <div
          v-for="index of maxIndex"
          :key="index"
          :class="['borderRadius30 cursor-pointer', index === activeIndex ? 'backgroundYellow' : 'backgroundDarkGrey']"
          style="width:30px;height:30px;"
          @click="activeIndex = index"
        >
          <!-- {{index}} -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntroCaroussel",
  data: function() {
    return {
      activeIndex: 1,
      maxIndex: 5
    };
  },
  computed: {
    device() {
      return this.$store.state.device;
    }
  },
  methods: {
    close() {
      this.$store.commit("setFirstVisit", false);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.IntroCarousselContainer {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;

  z-index: 2000;
  background-color: rgba(232, 232, 232, 0.65);

  -webkit-transform: translate3d(0, 0, 0);
  font-size: 16px;
}

.ContentContainer {
  position: absolute;
  width: 600px;
  top: 250px;
  left: calc(50% + 40px);
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 10px;
  padding: 20px 80px;
  overflow-y: auto;
}
@media (max-width: 768px) {
  .ContentContainer {
    left: 50%;
    top: 50%;
    width: 100%;
    height: fit-content;
    min-height: 100%;
    padding: 60px 20px 20px 20px;
    border-radius: 0;
  }
}

@media (max-width: 768px) {
  .ContentContainer {
    padding: 25px 10px 50px 10px;
  }
}

.ArrowContainer {
  position: absolute;
  font-size: 18px;
  line-height: 20px;
}

.benachrichtigungBeispiel {
  box-shadow: 3px 3px 3px 1px #9ba0a4;
}

.page {
  height: calc(100% - 30px);
  overflow-y: auto;
}

#mehrHessenMobilInfo {
  width: 700px;
}
</style>
